import React from 'react'
import styled, {css} from 'styled-components'
import presets from "../utils/presets"
import {rhythm} from "../utils/typography"

const Column = styled.section`
  width: calc(100% - ${rhythm(2)});
  max-width: :${rhythm(28)};
  position:relative;
  padding:5vh 0 0 0;
  width: calc(100% - ${rhythm(2)});
  max-width: ${rhythm(20)};
  margin: 0 auto;
  Link{
    display:inline-block;
  }
`

export default Column



// WEBPACK FOOTER //
// ./src/com/Column.js